export default {
  en: {
    INPUT_TEXT: {
      LABEL: 'Enter Value',
    }
  }
};